<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger':
          current.errors &&
          (current.errors.unidad_medida &&
          current.errors.unidad_medida.length > 0),
      }"
      >Unidad de Medida</label
    >
    <select
      class="form-control"
      v-model="current.unidad_medida"
      @change="onChangeSelect"
      v-if="current.productounidadmedida_set"
    >
      <option
        v-for="(unidad_medida, key) in current.productounidadmedida_set"
        :value="unidad_medida.unidad_medida.id"
        :key="key"
        >{{ unidad_medida.unidad_medida.nombre }}</option
      >
    </select>
    <select
      class="form-control"
      v-model="current.unidad_medida"
      @change="onChangeSelect"
      v-if="unidades_medidas"
    >
      <option
        v-for="(unidad_medida, key) in unidades_medidas"
        :value="unidad_medida.unidad_medida_obj.id"
        :key="key"
        >{{ unidad_medida.unidad_medida_obj.nombre }}</option
      >
    </select>
    <small
      v-if="current.errors && current.errors.unidad_medida"
      class="form-text text-danger"
      >{{ current.errors.unidad_medida[0] }}</small
    >
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Object,
      required: true,
      default: {
          sku: null,
          unidad_medida: null,
          errors: [],
        }
    },
    unidades_medidas: {
      type: Array,
      required: false
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    onChangeSelect() {
      this.$emit("onchangeselect");
    },
  },
};
</script>
